/* eslint-disable react/prop-types */
import React from 'react'
import { Button, Modal } from 'react-bootstrap'

/*
  GenericConirmationModal: Use this modal for generic single message confirmations. Keep it simple.
  *  {- props -}
  *  @show <bool> : show or not bool
  *  @title <string> : Main title message
  *  @message <string> : Main body message
  *  @primaryButton <object> : {variant, text}
  *  @onSubmit <function> : What to happen on primary button press
  *  @onHide <function> : What to happen on secondary button press
*/
function GenericConfirmationModal(props) {
  const { show, title, message, primaryButton, secondaryButton, onSubmit, onHide, onSecondary } = props

  return (
    <Modal size="md" centered aria-labelledby="contained-modal-title-vcenter" show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant={secondaryButton.variant} onClick={onSecondary || onHide}>
          {secondaryButton.text}
        </Button>
        <Button variant={primaryButton.variant} onClick={onSubmit}>
          {primaryButton.text}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default GenericConfirmationModal
